import React, { useEffect, useContext } from 'react';
import { TextInput, FileMultipleViewer, CardReply, TextViewer } from '../../components';
import { useForm } from '../../hooks';
import { SnackbarContext, DialogContext } from '../../contexts';
import Handler from '../../Handler';
import API from '../../api';
import _ from 'lodash';
import { useParams } from 'react-router-dom';

export const CsInquiryDetailPage = (props) => {
  const { slug } = useParams();
  const { updateSnackbar } = useContext(SnackbarContext);
  const { dialog, updateDialog } = useContext(DialogContext);
  const [formData, formMeta, formChange, setFormData] = useForm(
    {
      answerContent: null,
      answerDate: null,
      answerId: null,
      content: '',
      createdAt: 0,
      email: 'test@coredot.io',
      files: [],
      inquiryDate: '',
      name: '',
      phone: '',
      seq: 0,
      site: '',
      status: '',
      title: '',
      type: '',
    },
    {
      name: {
        key: 'name',
        label: '이름',
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
      },
      email: {
        key: 'email',
        label: '이메일',
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
      },
      phone: {
        key: 'phone',
        label: '전화번호',
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
      },
      title: {
        key: 'title',
        label: '제목',
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
      },
      type: {
        key: 'title',
        label: '문의 타입',
        fullWidth: true,
        render: (value) => {
          return Handler.ENUM.CS.TYPE(value);
        },
      },
      content: {
        key: 'content',
        label: '문의내용',
        type: 'text',
        multiline: true,
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
      },
      files: {
        type: 'file',
        key: 'files',
        label: '첨부파일',
        path: 'dummy',
        max: 10,
      },
      inquiryDate: {
        key: 'inquiryDate',
        label: '문의일자',
        type: 'text',
        fullWidth: true,
        InputProps: {
          readOnly: true,
        },
        render: (value) => {
          return Handler.getYYYYMMDDhhmmssByUnix(value);
        },
      },
    },
  );

  useEffect(() => {
    if (slug) {
      refreshData();
    }
  }, [slug]);

  const refreshData = () => {
    API.CS.GetInquiryDetail(slug).then(
      (res) => {
        let result = res.data;
        console.log('GetInquiryDetail result', result);
        setFormData(result);
      },
      (err) => {
        console.log('err', err);
        updateSnackbar({
          type: 'error',
          open: true,
          message: err.data.message,
        });
      },
    );
  };

  console.log('formData', formData);

  const requestReplyConfrim = (value) => {
    if (value) {
      updateDialog({
        type: 'info',
        open: true,
        title: '답변 등록',
        description: '등록 후 되돌릴 수 없습니다. 그래도 진행하시겠습니까?',
        onConfirm: () => {
          console.log('confirm work', value);
          API.CS.PutInquiryAnswer(slug, { answer: value }).then(
            (res) => {
              let result = res.data;
              refreshData();
            },
            (err) => {
              console.log('err', err);
              updateSnackbar({
                type: 'error',
                open: true,
                message: err.data.message,
              });
            },
          );
        },
      });
    } else {
      updateSnackbar({
        type: 'error',
        open: true,
        message: '내용을 입력하세요.',
      });
    }
  };

  return (
    <article className='basic-page'>
      <section className='content-header__container'>
        <header>
          <h3>상담문의 상세</h3>
        </header>
      </section>
      <section className='form__container'>
        <header>
          <h3>문의 정보</h3>
        </header>
        <div className='flex'>
          <TextInput value={formData.name} onChange={formChange} meta={formMeta.name}></TextInput>
          <TextInput value={formData.email} onChange={formChange} meta={formMeta.email}></TextInput>
          <TextInput value={formData.phone} onChange={formChange} meta={formMeta.phone}></TextInput>
          <TextViewer value={formData.type} meta={formMeta.type}></TextViewer>
          <TextViewer value={formData.createdAt} meta={formMeta.inquiryDate}></TextViewer>

          {/* <TextInput value={formData.inquiryDate} onChange={formChange} meta={formMeta.inquiryDate}></TextInput> */}
          <TextInput value={formData.title} onChange={formChange} meta={formMeta.title}></TextInput>
          <TextInput value={formData.content} onChange={formChange} meta={formMeta.content}></TextInput>
          <FileMultipleViewer value={formData.files} onChange={formChange} meta={formMeta.files}></FileMultipleViewer>
        </div>
      </section>
      <section className='card__container' style={{ marginTop: 40 }}>
        <CardReply data={formData} requestSubmit={requestReplyConfrim}></CardReply>
      </section>
    </article>
  );
};
